<template>
  <div
    v-if="hasAccess"
    class="fill-height"
  >
    <v-row class="d-flex justify-center">
      <v-col
        cols="12"
        md="3"
        sm="4"
      >
        <v-select
          v-model="selectedForm"
          :items="selectedFormOptions"
          :label="$vuetify.lang.t('$vuetify.form.name')"
          outlined
        />
      </v-col>
    </v-row>
    <v-row class="d-flex justify-center fill-height">
      <v-col cols="12">
        <template v-if="currentForm">
          <v-row>
            <v-col
              cols="12"
              class="buttons__container"
            >
              <v-select
                v-model="selectedFormInput"
                :items="selectedFormInputOptions"
                :label="$vuetify.lang.t('$vuetify.form.sum.inputField')"
                outlined
                dense
                hide-details
                style="max-width: 15%;"
              />
              <div class="buttons__mode">
                <v-btn
                  id="graph"
                  :class="{ primary: mode === 'graph' }"
                  @click="mode = 'graph'"
                >
                  <v-icon>mdi-chart-bar</v-icon>
                </v-btn>
                <v-btn
                  id="table"
                  :class="{ primary: mode === 'table' }"
                  @click="mode = 'table'"
                >
                  <v-icon>mdi-table-large</v-icon>
                </v-btn>
              </div>
              <div class="buttons__time">
                <v-btn
                  id="one_month"
                  :class="{ primary: selection === 'one_day' }"
                  @click="updateData('one_day')"
                >
                  {{ $vuetify.lang.t("$vuetify.day") }}
                </v-btn>
                <v-btn
                  id="one_week"
                  :class="{ primary: selection === 'one_week' }"
                  @click="updateData('one_week')"
                >
                  {{ $vuetify.lang.t("$vuetify.week") }}
                </v-btn>
                <v-btn
                  id="one_month"
                  :class="{ primary: selection === 'one_month' }"
                  @click="updateData('one_month')"
                >
                  {{ $vuetify.lang.t("$vuetify.month") }}
                </v-btn>
                <v-btn
                  id="one_year"
                  :class="{ primary: selection === 'one_year' }"
                  @click="updateData('one_year')"
                >
                  {{ $vuetify.lang.t("$vuetify.year") }}
                </v-btn>
                <v-btn
                  id="all"
                  :class="{ primary: selection === 'all' }"
                  @click="updateData('all')"
                >
                  {{ $vuetify.lang.t("$vuetify.all") }}
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <div v-show="mode === 'table' && selectedFormInput === null">
            <div class="mb-4">
              <v-card :loading="loading">
                <v-card-title>
                  {{ $vuetify.lang.t("$vuetify.generalInformation") }}
                  <div class="flex-grow-1" />
                  <download-group>
                    <download
                      format="csv"
                      :json="remapperUtil.remapAsClone(
                        filterUtil.whitelistAsClone(
                          tableData,
                          ['buttonName', 'value']
                        ),
                        [
                          {buttonName: $vuetify.lang.t('$vuetify.form.sum.buttonName')},
                          {value: $vuetify.lang.t('$vuetify.form.sum.value')},
                        ]
                      )"
                      text="csv"
                      icon-pos="left"
                    >
                      <v-icon>
                        mdi-file-delimited
                      </v-icon>
                    </download>
                    <download
                      format="xls"
                      :json="remapperUtil.remapAsClone(
                        filterUtil.whitelistAsClone(
                          tableData,
                          ['buttonName', 'value']
                        ),
                        [
                          {buttonName: $vuetify.lang.t('$vuetify.form.sum.buttonName')},
                          {value: $vuetify.lang.t('$vuetify.form.sum.value')},
                        ]
                      )"
                      text="xls"
                      icon-pos="left"
                    >
                      <v-icon>
                        mdi-file-excel
                      </v-icon>
                    </download>
                  </download-group>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="tableData"
                  :loading="loading"
                  :items-per-page="15"
                  class="elevation-1"
                />
              </v-card>
            </div>
          </div>
          <div v-show="mode === 'table' && selectedFormInput !== null">
            <div v-for="(item, i) in tableData" :key="i" class="mb-4">
              <v-card :loading="loading">
                <v-card-title>
                  {{ item.name || $vuetify.lang.t('$vuetify.default') }}
                  <div class="flex-grow-1" />
                  <download-group>
                    <download
                      format="csv"
                      :json="remapperUtil.remapAsClone(
                        filterUtil.whitelistAsClone(
                          item.tableData,
                          ['buttonName', 'value']
                        ),
                        [
                          {buttonName: $vuetify.lang.t('$vuetify.form.sum.buttonName')},
                          {value: $vuetify.lang.t('$vuetify.form.sum.value')},
                        ]
                      )"
                      text="csv"
                      icon-pos="left"
                    >
                      <v-icon>
                        mdi-file-delimited
                      </v-icon>
                    </download>
                    <download
                      format="xls"
                      :json="remapperUtil.remapAsClone(
                        filterUtil.whitelistAsClone(
                          item.tableData,
                          ['buttonName', 'value']
                        ),
                        [
                          {buttonName: $vuetify.lang.t('$vuetify.form.sum.buttonName')},
                          {value: $vuetify.lang.t('$vuetify.form.sum.value')},
                        ]
                      )"
                      text="xls"
                      icon-pos="left"
                    >
                      <v-icon>
                        mdi-file-excel
                      </v-icon>
                    </download>
                  </download-group>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="item.tableData"
                  :loading="loading"
                  :items-per-page="15"
                  class="elevation-1"
                />
              </v-card>
            </div>
            <div v-if="mode === 'table' && tableData.length <= 0">
              <v-card class="mx-auto">
                <v-row>
                  <v-col
                    cols="12"
                    class="d-flex justify-center align-center"
                  >
                    <div class="headline primary--text my-3">
                      {{ $vuetify.lang.t('$vuetify.noDataText') }}
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </div>
          <div v-show="mode === 'graph' && selectedFormInput === null">
            <div
              v-for="(item, key) in chartData"
              :key="key"
              class="mb-4"
            >
              <div v-if="ready">
                <v-card :loading="loading">
                  <v-card-title>
                    {{ item[0].name }}
                  </v-card-title>
                  <v-chart
                    type="bar"
                    height="350"
                    :options="buildChartOptions()"
                    :series="item"
                  />
                </v-card>
              </div>
            </div>
          </div>
          <div v-show="mode === 'graph' && selectedFormInput !== null">
            <div
              v-for="(item, key) in chartData"
              :key="key"
              class="mb-4"
            >
              <div v-if="ready">
                <v-card :loading="loading">
                  <v-card-title>
                    {{ item[0].name }}
                  </v-card-title>
                  <v-chart
                    type="bar"
                    height="350"
                    :options="buildChartOptions()"
                    :series="item"
                  />
                </v-card>
              </div>
            </div>
          </div>
          <div v-if="mode === 'graph' && Object.keys(chartData).length <= 0">
            <v-card class="mx-auto">
              <v-row>
                <v-col
                  cols="12"
                  class="d-flex justify-center align-center"
                >
                  <div class="headline primary--text my-3">
                    {{ $vuetify.lang.t('$vuetify.noDataText') }}
                  </div>
                </v-col>
              </v-row>
            </v-card>
          </div>
        </template>
        <template v-else>
          <v-card class="mx-auto">
            <v-row>
              <v-col
                cols="12"
                class="d-flex justify-center align-center"
              >
                <div class="headline primary--text my-3">
                  {{ $vuetify.lang.t('$vuetify.form.sum.selectForm') }}
                </div>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import objectPath from 'object-path';
import VueApexCharts from 'vue-apexcharts';
import apiUtil from '../utils/ApiUtil';
import filterUtil from '../utils/FilterUtil';
import remapperUtil from '../utils/RemapperUtil';
import DownloadComponent from './DownloadComponent.vue';
import DownloadGroupComponent from './DownloadGroupComponent.vue';

export default {
  components: {
    'v-chart': VueApexCharts,
    download: DownloadComponent,
    downloadGroup: DownloadGroupComponent,
  },
  data: () => {
    return {
      permissionsKey: 6,
      forms: [],
      selectedForm: null,
      selectedFormInput: null,
      currentForm: {},
      selection: 'one_day',
      mode: 'table',
      ready: false,
      loading: false,
      data: [],
      filterUtil,
      remapperUtil,
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    selectedFormOptions() {
      if (this.forms.length <= 0) {
        return [];
      }

      const selectedFormOptions = [];
      for (const item of this.forms) {
        selectedFormOptions.push({ text: item.name, value: item.id });
      }

      return selectedFormOptions;
    },
    selectedFormInputOptions() {
      if (!this.currentForm || Object.keys(this.currentForm).length <= 0) {
        return [];
      }

      const selectedFormInputOptions = [];
      selectedFormInputOptions.push({ text: this.$vuetify.lang.t('$vuetify.default'), value: null });
      for (const index in this.currentForm.inputs) {
        const item = this.currentForm.inputs[index];
        if (item.name) {
          selectedFormInputOptions.push({ text: item.name, value: parseInt(index, 10) + 1 });
        }
      }

      return selectedFormInputOptions;
    },
    chartData() {
      if (this.data.length <= 0 || !this.currentForm) {
        return [];
      }

      const isGroupByMode = this.selectedFormInput !== null;
      const preparedData = {};

      if (isGroupByMode) {
        const currentFormSum = this.data.filter((item) => { return item.form_id === this.currentForm.id; });
        for (const item of currentFormSum) {
          const inputName = item[`input_${this.selectedFormInput}`] || this.$vuetify.lang.t('$vuetify.default');
          preparedData[inputName] = [{ name: inputName, data: [] }];

          for (const index in this.currentForm.buttons) {
            const currentFormButton = this.currentForm.buttons[index];
            if (currentFormButton.name) {
              const preparedValue = objectPath.get(item, `button_${parseInt(index, 10) + 1}`, 0);
              preparedData[inputName][0].data.push({ x: currentFormButton.name, y: preparedValue });
            }
          }
        }
      } else {
        const currentFormSum = this.data.find((item) => { return item.form_id === this.currentForm.id; });
        preparedData.default = [{ name: this.$vuetify.lang.t('$vuetify.default'), data: [] }];
        for (const index in this.currentForm.buttons) {
          const item = this.currentForm.buttons[index];
          if (item.name) {
            const preparedValue = objectPath.get(currentFormSum, `button_${parseInt(index, 10) + 1}`, 0);
            preparedData.default[0].data.push({ x: item.name, y: preparedValue });
          }
        }
      }

      return preparedData;
    },
    headers() {
      return [
        { text: this.$vuetify.lang.t('$vuetify.form.sum.buttonName'), value: 'buttonName' },
        { text: `${this.$vuetify.lang.t('$vuetify.form.sum.value')}`, value: 'value' },
      ];
    },
    tableData() {
      if (this.data.length <= 0 || !this.currentForm) {
        return [];
      }

      const isGroupByMode = this.selectedFormInput !== null;
      const preparedData = [];

      if (isGroupByMode) {
        const currentFormSum = this.data.filter((item) => { return item.form_id === this.currentForm.id; });
        for (const item of currentFormSum) {
          const preparedTable = { name: item[`input_${this.selectedFormInput}`], tableData: [] };
          for (const index in this.currentForm.buttons) {
            const currentFormButton = this.currentForm.buttons[index];
            if (currentFormButton.name) {
              const preparedValue = objectPath.get(item, `button_${parseInt(index, 10) + 1}`, 0);
              preparedTable.tableData.push({ buttonName: currentFormButton.name, value: preparedValue });
            }
          }
          preparedData.push(preparedTable);
        }
      } else {
        const currentFormSum = this.data.find((item) => { return item.form_id === this.currentForm.id; });
        for (const index in this.currentForm.buttons) {
          const item = this.currentForm.buttons[index];
          if (item.name) {
            const preparedValue = objectPath.get(currentFormSum, `button_${parseInt(index, 10) + 1}`, 0);
            preparedData.push({ buttonName: item.name, value: preparedValue });
          }
        }
      }

      return preparedData;
    },
  },
  watch: {
    selectedForm: {
      handler(newValue) {
        this.currentForm = this.forms.find((item) => {
          return item.id === newValue;
        });
      },
      immediate: true,
    },
    selectedFormInput: {
      async handler() {
        await this.updateData(this.selection);
      },
      immediate: false,
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    const result = await apiUtil.getAllForms();
    this.forms = result;
    await this.updateData('one_day');
    setTimeout(() => {
      this.ready = true;
      this.$store.dispatch('setGlobalLoading', false);
    }, 100);
  },
  methods: {
    async updateData(selection) {
      this.selection = selection;
      this.loading = true;
      const inputId = this.selectedFormInput || null;
      switch (selection) {
        case 'one_day':
          this.data = await apiUtil.getDailySumStat(inputId);
          break;
        case 'one_month':
          this.data = await apiUtil.getMonthlySumStat(inputId);
          break;
        case 'one_week':
          this.data = await apiUtil.getWeeklySumStat(inputId);
          break;
        case 'one_year':
          this.data = await apiUtil.getYearlySumStat(inputId);
          break;
        case 'all':
          this.data = await apiUtil.getAllSumStat(inputId);
          break;
        default:
      }
      this.loading = false;
    },
    buildChartOptions() {
      const chartOptions = {
        colors: [],
        toolbar: {
          show: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent'],
        },
        yaxis: {
          title: {
            text: '',
          },
        },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {},
        },
      };

      chartOptions.yaxis.title.text = '';
      if (!chartOptions.colors.length) {
        chartOptions.colors.push('#796efd');
      }

      return chartOptions;
    },
  },
};
</script>
